var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83333 6.66667H3.33333C2.41667 6.66667 1.66667 5.91667 1.66667 5V3.33333C1.66667 2.41667 2.41667 1.66667 3.33333 1.66667H5.83333C6.75 1.66667 7.5 2.41667 7.5 3.33333V5C7.5 5.91667 6.75 6.66667 5.83333 6.66667Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3333 5.83333H14.3333C13.7833 5.83333 13.3333 5.38332 13.3333 4.83332V3.50001C13.3333 2.95001 13.7833 2.5 14.3333 2.5H17.3333C17.8833 2.5 18.3333 2.95001 18.3333 3.50001V4.83332C18.3333 5.38332 17.8833 5.83333 17.3333 5.83333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3333 12.0833H14.3333C13.7833 12.0833 13.3333 11.6333 13.3333 11.0833V9.75001C13.3333 9.20001 13.7833 8.75 14.3333 8.75H17.3333C17.8833 8.75 18.3333 9.20001 18.3333 9.75001V11.0833C18.3333 11.6333 17.8833 12.0833 17.3333 12.0833Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.5 4.16667H13.3333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.4167 4.16667V15C10.4167 15.9167 11.1667 16.6667 12.0833 16.6667H13.3333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.4167 10.4167H13.3333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.3333 18.3333H14.3333C13.7833 18.3333 13.3333 17.8833 13.3333 17.3333V16C13.3333 15.45 13.7833 15 14.3333 15H17.3333C17.8833 15 18.3333 15.45 18.3333 16V17.3333C18.3333 17.8833 17.8833 18.3333 17.3333 18.3333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequence);
export default __webpack_public_path__ + "static/media/sequence.c303e726a768faae1475cd25c1470e77.svg";
export { ForwardRef as ReactComponent };